<div
  class="text-container"
  [ngClass]="bgColorClass"
  [matTooltip]="displayName()">
  <span [ngClass]="colorClass">{{ getInitials }}</span>
</div>
